import React from "react";
import Button, { ButtonVariant } from "@/components/Button";
import { SlotIconName } from "@/components/Icon";
import classNames from "classnames";
import { FormValidationTooltip } from "./FormValidationTooltip";

interface MissingField {
  label: string;
  path: string;
}

interface ActionButtonProps {
  onClick: () => void;
  disabled: boolean;
  isLoading: boolean;
  variant?: ButtonVariant;
  children: React.ReactNode;
  missingFields?: MissingField[];
  showTooltip?: boolean;
  tooltipTitle?: string;
  loadingIcon?: SlotIconName;
  [key: string]: any; // For additional props like 'key'
}

export function ActionButton({
  onClick,
  disabled,
  isLoading,
  variant = "filled",
  children,
  missingFields = [],
  showTooltip = false,
  tooltipTitle = "Required Fields",
  loadingIcon = "progress_activity",
  ...props
}: ActionButtonProps) {
  const button = (
    <Button
      icon={isLoading ? loadingIcon : undefined}
      iconClassName={classNames(isLoading && "animate-spin w-6 h-6 !block")}
      disabled={disabled}
      variant={variant}
      onClick={onClick}
      {...props}
    >
      {children}
    </Button>
  );

  return (
    <FormValidationTooltip missingFields={missingFields} showTooltip={showTooltip} title={tooltipTitle}>
      {button}
    </FormValidationTooltip>
  );
}
